import React, {Component} from 'react';
import Nav from '../Nav/index';
import ExtraIcon from './extra-icon';

import './extras.scss';
import withAuth from "../../services/withAuth";

import FourQualities from "../../assets/images/HEA-Thumbnail-4-qualities-01.png";
import MoneyInterview from "../../assets/images/HEA-Thumbnail-money-and-marriage-01.png";
import DealingAnxiety from '../../assets/images/HEA-Thumbnail-anxiety-01.png';
import FamilyPlanning from "../../assets/images/HEA-Thumbnail-family-planning-01.png";
import FeelingWordList from "../../assets/images/HEA-Thumbnail-feelings-words-list-01.png";
import HoneymoonTips from "../../assets/images/HEA-Thumbnail-vacation-tips-01.png";
import Spirituality from "../../assets/images/HEA-Thumbnail-spirituality-01.png";
import TwogetherTexas from '../../assets/images/HEA-Thumbnail-twogether-in-texas-quiz-01.png';
import CourageousConfidence from '../../assets/images/Course-shopify-image-Contagious-Confidence.png';
import MoreMarriage from '../../assets/images/marriage365org-thumbnail.JPG';
import MensCourse from '../../assets/images/Mens-Course-shopify-image_1.jpg';
import CourseIntimacy from '../../assets/images/course-intimacy-m365.jpg';
import BeenThere from '../../assets/images/HEA-Thumbnail-Been-There-Done-That-01.png';
import BlendedFamily from '../../assets/images/HEA-Thumbnail-BLENDED-FAMILIES-01.png';
import Wait from '../../assets/images/HEA-Thumbnail-WAIT-01.png';
import ValidatingStatements from '../../assets/images/HEA-Thumbnail-validating-statements-01.png';
import Phrases from '../../assets/images/extras/HEA-Thumbnail-15-phrases-that-express-empathy-01.jpg';
import Questions from '../../assets/images/extras/HEA-Thumbnail-15-questions-to-ask-your-fiance-01.jpg'
import Commitment from '../../assets/images/extras/HEA-Thumbnail-commitment-to-communicate-01.jpg'
import Expressing from '../../assets/images/extras/HEA-Thumbnail-expressing-your-needs-01.jpg'
import LoveLanguages from '../../assets/images/extras/HEA-Thumbnail-five-love-languages-01.jpg'
import BusinessMeeting from '../../assets/images/extras/HEA-Thumbnail-weekly-marriage-business-meeting-01.jpg'
import BestWeddingTips from '../../assets/images/extras/HEA-Thumbnail-our-best-wedding-tips-01.png'


class Extras extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
        }
    }

    videos = [
        {
            title: 'Our Best Wedding Tips',
            img: BestWeddingTips,
            videoSource: 'https://d3ug1m98su9wd.cloudfront.net/ca7caeff-dcca-48ef-8b50-cd6a5e3bb9a5/hls/Our Best Wedding Tips_2.m3u8',
        },
        {
            title: '4 Qualities to look for in a mate',
            img: FourQualities,
            videoSource: 'https://d3ug1m98su9wd.cloudfront.net/e787987a-5d10-4a0a-95b2-6b387d1faa51/hls/4 Qualities to look for in a mate.m3u8',
        },
        {
            title: 'Honeymoon Tips',
            img: HoneymoonTips,
            videoSource: 'https://d3ug1m98su9wd.cloudfront.net/cf302c28-a998-42af-b434-a264bd35b703/hls/Honeymoon Tips __ Happily Ever After.m3u8',
        },
        {
            title: 'Dealing with Anxiety',
            img: DealingAnxiety,
            videoSource: 'https://d3ug1m98su9wd.cloudfront.net/a63b11e1-db2e-4f19-b501-2dc7757c323b/hls/Dealing with Anxiety.m3u8',
            connectingQuestions: 'https://d3ug1m98su9wd.cloudfront.net/resources/4_19+Dealing+with+Anxiety+-+HEA+CQ.pdf'
        },
        {
            title: 'Money Interview',
            img: MoneyInterview,
            videoSource: 'https://d3ug1m98su9wd.cloudfront.net/34b1b4f1-6c7f-45db-af04-749a784d6bc6/hls/Happily Ever After Intro - Marriage Money Webcast.m3u8',
        },
        {
            title: 'Family Planning & Parenting',
            img: FamilyPlanning,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/Family+Planning+and+Parenting+-+HEA+CQ.pdf'
        },
        {
            title: 'Feeling Words List',
            img: FeelingWordList,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/Feelings+Words+List.pdf'
        },
        {
            title: 'Twogether in Texas Quiz',
            img: TwogetherTexas,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/twogether-in-texas-quiz.pdf'
        },
        {
            title: 'Spirituality',
            img: Spirituality,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/Spirituality+-+HEA+CQ.pdf'
        },
        {
            title: 'Expressing Your Needs',
            img: Expressing,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-CS-expressing-your-needs.pdf'
        },
        {
            title: 'Commitment to Communicate',
            img: Commitment,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-CS-Commitment-to-Communicate.pdf'
        },
        {
            title: 'Weekly Marriage Business Meeting',
            img: BusinessMeeting,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-Weekly-Marriage-Business-Meeting.pdf'
        },
        {
            title: '15 Phrases That Express Empathy',
            img: Phrases,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-CS-15-phrases-that-express-empathy3.pdf'
        },
        {
            title: 'The Five Love Languages',
            img: LoveLanguages,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-Love-Languages.pdf'
        },
        {
            title: 'Listen to Your Fiance',
            img: Questions,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/HEA-CS-15-questions-you-can-ask-as-you-listen.pdf'
        },
        {
            title: 'Been There Done That',
            img: BeenThere,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/CS-HEA-Been-There-Done-That.pdf',
        },
        {
            title: 'Blended Families',
            img: BlendedFamily,
            pdfSource: "https://d3ug1m98su9wd.cloudfront.net/resources/CQ's-HEA-Blended-Families.pdf"
        },
        {
            title: 'W-A-I-T Why am I Talking?',
            img: Wait,
            pdfSource: "https://d3ug1m98su9wd.cloudfront.net/resources/CQs-HEA-WAIT.pdf"
        },
        {
            title: 'Validating Statements',
            img: ValidatingStatements,
            pdfSource: 'https://d3ug1m98su9wd.cloudfront.net/resources/CS-HEA-Validating-Statements.pdf'
        }
    ]
    downloads = [
        {
            title: 'Become A Member',
            img: MoreMarriage,
            pdfSource: 'http://marriage365.org/join'
        }
    ];
    componentDidMount(){
        window.scrollTo(0, 0);
    }

    slugify = (title) => {
        return title.split(' ').join('-').toLowerCase();
    }

    extrasSection = (array) => {
        return array.map((e, i) => {
            return <ExtraIcon imgSrc={e.img}
                              title={e.title}
                              key={`video-${i}`}
                              videoSource={e.videoSource}
                              connectingQuestions={e.connectingQuestions}
                              pdfSource={e.pdfSource}
                              slug={this.slugify(e.title)}/>
        });

    }

    handleClick = (e) => {

        // console.log("click triggered",e.target);
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')) {
            return;
        }

        // if (target.classList.contains('close-menu')){
        if (this.state.showMenu) {
            this.setState({
                showMenu: false
            })
        }
        // }
        // console.log("close triggered" ,e.target);
    }

    render() {
        // console.log("extras content" , this.videoLinks, this.downloads, this.videos);

        return (
            <div id="extras" onClick={this.handleClose}>
                <Nav showMenu={this.state.showMenu} handleClick={this.handleClick} handleClose={this.handleClose}/>
                <div className="extras-page">
                <a className="back-btn bonus" href="/progress"><i className="fa fa-arrow-left"></i></a>
                    <h1>Extras</h1>
                    <div className="extras-container">
                        {this.extrasSection(this.videos)}
                    </div>
                    <h1>After the Wedding</h1>
                    <div className="extras-container after-wedding">
                        {this.extrasSection(this.downloads)}
                    </div>
                </div>
            </div>
        )


    }

}

export default withAuth(Extras);
